module.exports = __webpack_public_path__ + "static/img/农机.d1e570d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/农机.jpg
// module id = vPy5
// module chunks = 1